/* eslint-disable */
import { useTranslation } from "react-i18next";
import {useEffect, useState} from 'react';
import ECharts from 'echarts-for-react';
import Papa from 'papaparse';
import { Chip } from '@mui/material';

import MainCard from 'components/MainCard';
import { getDownloadDirectByQuery } from 'components/axios/fileManagerAxios';

const chartDataInit = {
  // darkmode:true,
  textStyle : {
      color : '#ffffff'
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
      data : [],
      left : 'center',
      top: 0,
      backgroundColor : '#fff'
  },
  grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
  },
  xAxis: {
      type: 'category',
      boundaryGap: false,
      data: []
  },
  yAxis: {
      type: 'value'
  },
  series: []
}

// function CSVReaderGraphTab({sensorId, type="default", isPrinting=false}) {
function CSVReaderGraphTab({options, remainLife, isLoading}) {
  const { t } = useTranslation();

  // const [options, setOptions] = useState({chartDataInit});

  // const [file, setFile] = useState(null);
  // const [isLoading, setIsLoading] = useState(false);

  // const [remainLife, setRemainLife] = useState(0); 
  // // const [lifeSpanGraphDatas, setLifeSpanGraphDatas] = useState(null);

  // useEffect(()=>{
  //   getDownloadDirectByQuery({fileGroup:"LER",id:sensorId}).then((res) => {
  //     return res;
  //   }).then((blob) => {
  //     setFile(blob);
  //     setIsLoading(true);
  //   })
  //   .catch((err) => {
  //       setFile(null);
  //       setIsLoading(false);
  //   });
  // },[sensorId]);

  // useEffect(()=>{
  //   if (isLoading) {
  //     handleParse();
  //   }
  // },[isLoading]);
  
  // const handleParse = () => {
  //   const reader = new FileReader();
  //   reader.onload = async ({ target }) => {
  //     const csv = Papa.parse(target.result, { header: true });
  //     const parsedData = csv?.data;
  //     const columns = Object.keys(parsedData[0]);
  //     const datas = parsedData[0];
  //     setRemainLife(parseInt(datas[columns[3]]));
  //     let optionsCopy = {...chartDataInit};
  //     let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
  //     let lifeSpans = [];
  //     let remainLifeSpans = [];
  //     parsedData.map(function(row, i) {
  //       if (row[columns[0]] && row[columns[0]] !== '') {
  //         chartDataCopy.xAxis.data.push(row[columns[0]]);
  //         lifeSpans.push((Math.round(row[columns[1]]*100)/100 || 0));
  //         remainLifeSpans.push((Math.round(row[columns[2]]*100)/100 || 0));
  //       }
  //     });
  //     chartDataCopy.series.push({name:t('message.common.text.lifespan.index'), type: 'line', areaStyle: {}, data : lifeSpans});
  //     chartDataCopy.series.push({name:t('message.common.text.expect.lifespan.index'), type: 'line', areaStyle: {}, data : remainLifeSpans});
  //     chartDataCopy.legend.data.push(t('message.common.text.lifespan.index'));
  //     chartDataCopy.legend.data.push(t('message.common.text.expect.lifespan.index'));
  //     setOptions(chartDataCopy);
  //     // setLifeSpanGraphDatas(chartDataCopy);
  //   };
  //   reader.readAsText(file);
  // };

  return (
    <>
    {isLoading && options !== null && remainLife !== 0 && 
    <MainCard style={{marginTop:"10px"}} content={false}>
        {/* <Chip label={`${t('message.common.chip.expect.lifespan')} (${t('message.common.chip.remain.lifespan')}:${remainLife}${t('message.common.text.month')})`} color="primary" /> */}
        <Chip label={`(${t('message.common.chip.remain.lifespan')}:${remainLife}${t('message.common.text.month')})`} color="primary" />
        {/* {isPrinting ?
        <ECharts
          option={options}
          opts={{ renderer: 'svg', width:"1000px", height: '250px' }}
          />
        : */}
        <ECharts
          option={options}
          opts={{ renderer: 'svg', height: '250px' }}
          />
        {/* } */}
    </MainCard>
    }
    </>
  )
}
 
export default CSVReaderGraphTab;